module.exports = __webpack_public_path__ + "static/media/next-arrow-white.594903ac.svg";